<template>
    <div class="note-form d-flex flex-column">
        <div class="form-group">
            <label for="author">Autor</label>
            <input
                type="text"
                name="author"
                id="author"
                disabled="true"
                class="form-control"
                :value="!!supervisor ? supervisor.name : user.name"
            />
        </div>
        <app-form-select-input
            v-if="clientRequired"
            label="Punto de acceso"
            :options="accessPoints"
            v-model="accessPointId"
            :hasError="$v.accessPointId.$error"
            errorMessage="Debe seleccionar el punto de acceso"
            @change="$v.accessPointId.$touch()"
        />
        <app-form-select-input
            placeholder="Tipo de anotación"
            :options="annotationTypes"
            v-model="annotationType"
            :is-object="true"
            :hasError="$v.annotationType.$error"
            errorMessage="Debe seleccionar el tipo de anotación"
            @change="noteTypeChange(!!annotationType ? annotationType.id : '')"
        />
        <div v-if="annotationType">
            <b-row>
                <b-col cols="12" md="6" lg="3">
                    <b-btn
                        v-b-toggle.collapse1
                        variant="primary"
                        class="btn-block"
                        ><i class="fa fa-plus" aria-hidden="true"></i> Agregar
                        fotos</b-btn
                    >
                </b-col>
            </b-row>
            <b-collapse id="collapse1" class="mt-2">
                <b-row>
                    <b-col cols="12" lg="3"></b-col>
                    <b-col cols="12" md="12" lg="6">
                        <b-card>
                            <div class="card-text">
                                <app-upload-or-take-photo
                                    id="note-photos"
                                    title="Fotos de Minuta"
                                    v-model="files"
                                />
                                <div v-if="files.files && files.files.length">
                                    <button
                                        class="btn btn-sm btn-danger pull-right"
                                        @click="cancelFilesSelected"
                                    >
                                        <i
                                            class="fa fa-trash-o"
                                            aria-hidden="true"
                                        ></i>
                                        Cancelar archivos seleccionados
                                    </button>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col cols="12" lg="3"></b-col>
                </b-row>
            </b-collapse>

            <component
                name="form"
                :is="theForm"
                v-model="content"
                ref="form"
            ></component>
            <div
                class="form-group"
                v-if="annotationType.slug === 'transitoria'"
            >
                <app-autocomplete
                    placeholder="Usuario asociado"
                    :items="operatives"
                    v-model="selectOperative"
                />
            </div>
            <b-form-checkbox
                v-model="sendNotification"
                v-if="annotationType.slug !== 'novedad'"
            >
                Enviar notificación a la administración del cliente
            </b-form-checkbox>
        </div>
    </div>
</template>
<script>
import notebookRepository from '../../../../repositories/notebook.repository'
import structuresRepository from '../../../../repositories/structures.repository.js'
import userRepository from '../../../../repositories/users.repository.js'
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import { required } from 'vuelidate/lib/validators'
import NoteFormNews from './NoteForms/NoteFormNews.vue'
import NoteFormBasic from './NoteForms/NoteFormBasic.vue'
import UploadOrTakePhoto from '../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import { mapGetters } from 'vuex'
import { getCurrentPosition } from '../../../../utils/localization'
export default {
    components: {
        appNoteFormNews: NoteFormNews,
        appNoteFormBasic: NoteFormBasic,
        appAutocomplete: Autocomplete,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },
    props: {
        onSave: Function,
        theClientId: {
            default: '',
        },
        supervisor: {
            type: Object,
            default: null,
        },
        geolocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            content: '',
            annotationType: '',
            form: '',
            files: '',
            clientRequired: false,
            accessPoints: [],
            accessPointId: '',
            sendNotification: false,
            operatives: [],
            selectOperative: '',
        }
    },
    watch: {
        theClientId(val) {
            if (val) {
                this.loadAccessPoints()
            }
        },
    },
    validations() {
        if (this.clientRequired) {
            return {
                content: { required },
                annotationType: { required },
                accessPointId: { required },
            }
        } else {
            return {
                content: { required },
                annotationType: { required },
            }
        }
    },
    methods: {
        loadOperatives() {
            const ur = { ...userRepository }
            ur.getOperatives()
                .then(data => {
                    data.map(item => {
                        const operative = {
                            ...item,
                            name: item.name + ' (' + item.profile.name + ')',
                        }
                        this.operatives.push(operative)
                    })
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrio un error al cargar los vigilantes y escoltas'
                    )
                )
        },
        loadAccessPoints() {
            const sr = { ...structuresRepository }
            const clientId = !!this.theClientId
                ? this.theClientId
                : !!this.client
                ? this.client.id
                : null
            if (!clientId) return
            sr.accessPointsByClient(clientId)
                .then(
                    data =>
                        (this.accessPoints = data.map(item => ({
                            ...item,
                            name: `${item.name} (Sede: ${item.venue.name})`,
                        })))
                )
                .catch(error =>
                    toastr.error(
                        'Error al cargar los puntos de acceso para las minutas'
                    )
                )
        },
        cancelFilesSelected() {
            this.$bus.$emit('note-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        async saveNote() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Ingrese todos los campos')
                return false
            }

            let form = this.$children.find(item => item.$attrs.name === 'form')
            if (!form || !form.isValid()) return

            const formData = new FormData()

            const { latitude, longitude } = await getCurrentPosition()
            formData.append('latitude', latitude)
            formData.append('longitude', longitude)

            formData.append('content', this.content)
            formData.append('annotationTypeId', this.annotationType.id)
            formData.append(
                'userId',
                !!this.supervisor ? this.supervisor.id : this.user.id
            )
            formData.append(
                'structureId',
                !!this.clientRequired ? this.accessPointId : this.accessPoint.id
            )
            formData.append(
                'operativeId',
                !!this.selectOperative ? this.selectOperative.id : -1
            )
            formData.append('sendNotification', !!this.sendNotification ? 1 : 0)

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('files[]', item)
                )
            }

            notebookRepository
                .saveNote(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanFields()
                        this.$bus.$emit('note-list.refresh')
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al guardar la minuta')
                })
        },
        fieldChange(field, value) {
            $v[field].$touch()
            this.$bus.$emit('note-update-field', field, value)
        },
        noteTypeChange(noteTypeId) {
            this.$v.annotationType.$touch()
            if (this.$v.annotationType.$invalid) {
                return false
            }

            let type = this.annotationTypes.find(
                item => item.id === parseInt(noteTypeId)
            )

            this.form = type.form
        },
        cleanFields() {
            this.$bus.$emit('note-photos.clean')
            ;(this.content = ''),
                (this.annotationType = ''),
                (this.selectOperative = ''),
                (this.accessPointId = '')
            this.sendNotification = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        initialize() {
            this.clientRequired = !this.user.profile.client_required
                ? true
                : false
            if (this.clientRequired) {
                this.loadAccessPoints()
            }
            this.loadOperatives()
        },
    },
    computed: {
        ...mapGetters(['annotationTypes']),
        theForm() {
            return !!this.form ? this.form : 'appNoteFormBasic'
        },
    },
    created() {
        this.load('annotationTypes')
        this.initialize()
    },
    mounted() {
        this.$bus.$on('save-note', this.saveNote)
        this.$bus.$on('note-form.clean', this.cleanFields)

        if (!!this.client) this.loadAccessPoints()
    },
    beforeDestroy() {
        this.$bus.$off('save-note')
        this.$bus.$off('note-form.clean')
    },
}
</script>
